module.exports = __webpack_public_path__ + "static/img/icon-list.c8390cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-list.png
// module id = xY8Q
// module chunks = 1